import PromptTemplateDataTable from '../components/PromptTemplateDataTable';

export default function CategoryComboPrompts() {
  return <PromptTemplateDataTable templateType="category_combo" />;
}
